import PropTypes from "prop-types";
import { Close } from "@mui/icons-material";
import { DialogTitle, IconButton } from "@mui/material";

export const CustomDialogTitle = ({ title, onClose, ...props }) => (
  <DialogTitle sx={{ display: "flex", alignItems: "center" }} {...props}>
    {title}
    {onClose && (
      <IconButton sx={{ ml: "auto" }} onClick={onClose}>
        <Close />
      </IconButton>
    )}
  </DialogTitle>
);

CustomDialogTitle.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
};
